export default __webpack_public_path__ + "static/media/user.b75f7e5e.svg";